const getDefaultState = () => {
  return {
    userInfo: {},
    menuData: [],
  }
}

const state = getDefaultState()

const mutations = {
  SET_USER_INFO: (state, params) => {
    state.userInfo = params;
  },
  SET_MENU_DATA: (state, params) => {
    state.menuData = params;
  }
}

const actions = {
  changeUserInfo({commit}, params) {
    commit('SET_USER_INFO', params);
  },
  changeMenuData({commit}, params) {
    console.log('changeMenuData', params);
    commit('SET_MENU_DATA', params);
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

